import React from "react";
import MasterCardSkeleton from "./MasterCardSkeleton";
import "../../DataEntryOperator/Goals/Goals.css";
import "./MasterCompanyMaster.css";

/* Full-page skeletons used as the lazy-route Suspense fallbacks for the Masters
   Company-Master screens, so opening them shows a page-specific placeholder
   (styled header + card grid) instead of the generic <Loader/> while the JS
   chunk downloads. The gp-/goalspage CSS ships in the main bundle because
   these skeletons are imported eagerly in navigation/index.tsx. */

const IconBack = () => (<svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" /></svg>);

/* dimmed header shell shared by the archived skeletons */
const ArchivedHead = ({ title }: { title: string }) => (
    <div className="gp-head">
        <span className="gp-btn gp-icon gp-back" style={{ opacity: 0.55 }}>
            <IconBack />
        </span>
        <div className="gp-headings">
            <h1 className="gp-title">{title}</h1>
            <span className="cd-skl" style={{ width: 120, height: 11, borderRadius: 6, marginTop: 6, opacity: 0.55 }} />
        </div>
    </div>
);

/* Main Company Master route — the hub is a single half-width card with a
   3-button action strip (Edit / Accreditations / Branches). */
export const MasterCompanyMasterSkeleton = () => (
    <div className="page-content-wraper goalspage">
        <div className="gp-head">
            <div className="gp-headings">
                <h1 className="gp-title">Company Master</h1>
                <span className="cd-skl" style={{ width: 150, height: 11, borderRadius: 6, marginTop: 6, opacity: 0.55 }} />
            </div>
        </div>
        <MasterCardSkeleton solo rows={3} actions={3} />
    </div>
);

export const ArchivedBusinessAccreditationSkeleton = () => (
    <div className="page-content-wraper goalspage">
        <ArchivedHead title="Archived Business Accreditations" />
        <MasterCardSkeleton count={6} rows={2} actions={1} />
    </div>
);

export const ArchivedBranchesSkeleton = () => (
    <div className="page-content-wraper goalspage">
        <ArchivedHead title="Archived Branches" />
        <MasterCardSkeleton count={6} rows={3} actions={1} />
    </div>
);
